/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { OpenAIEffort, OpenAIModels } from "../enums";
export const promptSchema = z.object({
  createdAt: z.string().datetime().nullish(),
  description: z.string().nullish(),
  effort: z.nativeEnum(OpenAIEffort).nullish(),
  id: z.string().uuid(),
  key: z.string().nullish(),
  model: z.nativeEnum(OpenAIModels).nullish(),
  prompt: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  updatedBy: z.string().uuid().nullish(),
});

export type Prompt = z.infer<typeof promptSchema>;
